export const updateTableMixin = {
    data() {
        return {}
    },
    methods: {
        updatePageDataBySearch() {
            this.getData('search')
        },
        updateData(tab,name) {
            this.getData('search',tab,name)
        },
        updatePageData() {
            this.getData('deleteSecOrdTag')
        }
    }
}
